module.exports = __webpack_public_path__ + "img/hospital.3a8d3565.png";